"use client";
import React from "react";
import { Link } from "@/i18n/routing";

import { sendGTMEvent } from "@next/third-parties/google";
import { useRouter, usePathname } from "next/navigation";

export default function MiddleHeader({
  scanner,
  blog,
  multichat,
  scannerprofile,
}) {
  const router = useRouter();
  const pathname = usePathname();
  const currentPath = pathname.slice(3);

  const isAuthPage =
    currentPath === "/auth/signin" || currentPath === "/auth/signup";

  const isProfilePage =
    currentPath === "/profile/scanner" || currentPath === "/profile/multichat";
  const isPaymentPage =
    currentPath === "/checkout" ||
    currentPath === "/checkout/payment" ||
    currentPath === "/checkout/success" ||
    currentPath === "/checkout/fail";
  const googleTagHandler = (event) => {
    sendGTMEvent({ event });
  };
  return (
    <div className={`${!isAuthPage && !isPaymentPage ? "mx-auto" : ""}`}>
      {!isAuthPage && !isProfilePage && !isPaymentPage && (
        <div className="text-base items-center gap-6  hidden md:flex">
          <Link
            href="/multichat"
            onClick={() => googleTagHandler("header_click_multichat")}
            className={`cursor-pointer hidden md:block ${currentPath === "/multichat" ? "text-foreground/80" : ""}`}
          >
            {multichat}
          </Link>
          <Link
            href="/scanner"
            onClick={() => googleTagHandler("header_click_scanner")}
            className={`cursor-pointer hidden md:block ${currentPath === "/scanner" ? "text-foreground/80" : ""}`}
          >
            {scanner}
          </Link>
          <Link
            href="/blog"
            onClick={() => googleTagHandler("header_click_blog")}
            className={`cursor-pointer hidden md:block ${currentPath === "/blog" ? "text-foreground/80" : ""}`}
          >
            {blog}
          </Link>
        </div>
      )}
      {isProfilePage && !isAuthPage && !isPaymentPage && (
        <div className="hidden sm:flex gap-4">
          <Link
            href="/profile/scanner"
            className={`cursor-pointer hidden md:block ${currentPath === "/profile/scanner" ? "text-foreground/80" : ""}`}
          >
            {scannerprofile}
          </Link>
          <Link
            href="/profile/multichat"
            className={`cursor-pointer hidden md:block ${currentPath === "/profile/multichat" ? "text-foreground/80" : ""}`}
          >
            {multichat}
          </Link>
        </div>
      )}
    </div>
  );
}
